"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelMutation = void 0;
var FractionalIndex_1 = require("./FractionalIndex");
var ModelOperation_1 = require("./ModelOperation");
var _a = ModelOperation_1.ModelOperation.codes, $xnoop = _a.$xnoop, $cappend = _a.$cappend, $cset = _a.$cset, $ctruncate = _a.$ctruncate, $xcreate = _a.$xcreate, $xdelete = _a.$xdelete;
var _b = ModelOperation_1.ModelOperation.results, $pass = _b.$pass, $fail = _b.$fail;
var ModelMutation = /** @class */ (function () {
    function ModelMutation(model, streamInput) {
        this.model = model;
        this.streamInput = streamInput;
        this.actualMode = 1;
        this.applyBatch = [];
        this.revertBatch = [];
        this.writeSet = new Set();
        this.changeBuffer = null;
        this.key = null;
        this.strict = true;
        this.metadata = {};
    }
    Object.defineProperty(ModelMutation.prototype, "mode", {
        get: function () {
            return this.actualMode;
        },
        set: function (mode) {
            if (this.actualMode === 2 && mode === 1) {
                throw new Error('ModelMutation: once mutation set to rolling mode, it cannot be changed.');
            }
            this.actualMode = mode;
        },
        enumerable: false,
        configurable: true
    });
    ModelMutation.prototype.perform = function (mmc) {
        this.changeBuffer = this.model.beginMutation();
        try {
            if (mmc(this) !== false) {
                this.model.promoteMutationToStaging();
                return {
                    key: this.key,
                    mode: this.mode,
                    applyBatch: Object.freeze(this.applyBatch),
                    revertBatch: Object.freeze(this.revertBatch),
                    writeSet: Object.freeze(this.writeSet),
                    metadata: Object.freeze(this.metadata),
                };
            }
        }
        catch (e) {
            // eslint-disable-next-line no-console
            this.model.cancelMutation();
            throw e;
        }
        return null;
    };
    ModelMutation.prototype.exec = function (moop) {
        this.stage(moop);
    };
    ModelMutation.prototype.execAll = function (moops) {
        var _this = this;
        moops.forEach(function (m) { return _this.stage(m); });
    };
    ModelMutation.prototype.noop = function () {
        this.stage([$xnoop]);
    };
    ModelMutation.prototype.componentCreate = function (id, type) {
        this.stage([$xcreate, id, 'component', type]);
    };
    ModelMutation.prototype.componentSet = function (id, key, value) {
        this.stage([$cset, id, key, value]);
    };
    ModelMutation.prototype.componentAppend = function (id, subject, before) {
        this.stage([$cappend, id, subject, this.computeFractionalKeyForAppend(id, before)]);
    };
    ModelMutation.prototype.componentTruncate = function (id, subject) {
        this.stage([$ctruncate, id, subject]);
    };
    ModelMutation.prototype.delete = function (id) {
        this.stage([$xdelete, id]);
    };
    ModelMutation.prototype.stage = function (moop) {
        var _this = this;
        // Resolve handler and validate
        var handler = ModelOperation_1.ModelOperation.getHandler(moop[0]);
        var _a = __read(handler.validate(this.model, moop), 2), result = _a[0], detail = _a[1];
        if (result === $pass) {
            // If okay, get the reverse moop
            var remoop = handler.reverse(this.model, moop);
            // Apply change to buffer
            handler.stage(this.changeBuffer, moop);
            // Store the moop and remoop
            this.applyBatch.push(moop);
            this.revertBatch.push(remoop);
            // Add the affected entities to the writeSet
            handler.entities(moop).forEach(function (x) { return _this.writeSet.add(x); });
            // Notify
            this.model.notifyMutationUpdated(moop);
            this.streamInput.emit('modelOperation', moop);
        }
        else if (result === $fail && this.strict) {
            // If in strict mode and we failed validation, raise exception.  Non-strict mode will simply skip this operation.
            throw new Error(detail);
        }
        return this;
    };
    ModelMutation.prototype.computeFractionalKeyForAppend = function (id, before) {
        var children = this.model.getChildren(id);
        var key = FractionalIndex_1.FractionalIndex.insertBefore(children, before);
        return key;
    };
    return ModelMutation;
}());
exports.ModelMutation = ModelMutation;
